import React, { PureComponent } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

const COLORS = ["#008273", "#F87171", "#DD5352", "#B5B4D0"];

const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

export default class SimplePieChart extends PureComponent {
  render() {
    const { data, useColorsTwo } = this.props;

    if (data === undefined) {
      return <div />;
    }

    const total = data.reduce((a, b) => a + b.value, 0);

    return (
      <ResponsiveContainer>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie data={data} innerRadius={30} outerRadius={50} fill="#8884d8" paddingAngle={1} dataKey="value">
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                stroke="rgba(255,255,255,0)"
                fill={
                  entry.color
                    ? entry.color
                    : useColorsTwo
                      ? colorsTwo[index % colorsTwo.length]
                      : COLORS[index % COLORS.length]
                }
              />
            ))}
          </Pie>
          <Tooltip formatter={(value, name, props) => value + " (" + Math.round((props.value / total) * 100) + "%)"} />
          <Legend
            layout={"vertical"}
            align={"right"}
            verticalAlign={"middle"}
            formatter={(value, entry, index) => value + ": " + Math.round((data[index].value / total) * 100) + "%"}
            iconType={"circle"}
          />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
